/**
 * GA4 커스텀 이벤트 전송기 — GTM(dataLayer) 경유.
 *
 * 시선(sisun-react)의 동명 모듈은 gtag 직접 호출이지만, 리뷰드는 GTM 만 실려 있어
 * (layout.tsx 의 GoogleTagManager) 발신 경로가 다르다: dataLayer.push 로 밀고,
 * GA4 전달은 GTM 콘솔의 커스텀 이벤트 트리거 + GA4 이벤트 태그가 맡는다
 * (lawkit generate_lead 와 같은 배선 — 태그 설정 없이는 이벤트가 GA4 에 안 닿는다).
 *
 * GTM 미로딩(로컬·프리뷰)에도 호출부가 조건문을 달지 않아도 되게 여기서 한 번만 방어한다.
 */
type DataLayerWindow = Window & {
  dataLayer?: Array<Record<string, unknown>>
}

export const trackEvent = (name: string, params: Record<string, string | number | boolean> = {}) => {
  if (typeof window === "undefined") return

  const w = window as DataLayerWindow
  w.dataLayer = w.dataLayer || []
  w.dataLayer.push({ event: name, ...params })
}
